export default __webpack_public_path__ + "static/media/message.cc616f81.svg";